const isAbsoluteUrl = (url: string) => /^(?:[a-z]+:)?\/\//i.test(url);

export default isAbsoluteUrl;
